import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  min-height: 100vh;
  background-color: ${props => props.bgColor};
`

export const HomeSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  background-color: ${props => props.bgColor};
  padding: 20px;
`

export const SearchedVideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.bgColor};
  padding: 30px;
`

export const TrendingHeadContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: ${props => props.bgColor};
  color: ${props => props.color};
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`

export const TrendingLogo = styled.div`
  background-color: #ff6b6b;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  color: #fff;
  font-size: 24px;

  &:hover {
    background-color: #ff3d3d;
    transition: background-color 0.3s ease;
  }
`

export const VideosContainer = styled.ul`
  display: grid;
  grid-template-columns: 1fr; /* One card per row */
  gap: 20px; /* Space between cards */
  padding: 0; /* Remove padding */
  list-style-type: none; /* No list styles */
`

export const TrendingHead = styled.h1`
  color: ${props => props.color};
  font-family: 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: bold;
`

export const ProductsLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const HomeStickyContainer = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
`

export const Image = styled.img`
  width: 300px;
  margin: 20px;
`

export const Heading = styled.h1`
  color: black;
  text-align: center;
  font-size: 30px;
  font-family: 'Roboto', sans-serif;
  margin-bottom: 20px;
`

export const Desc = styled.p`
  color: black;
  text-align: center;
  font-size: 18px;
`

export const NavLink = styled(Link)`
  color: #007bff;
  text-decoration: none;
  margin-top: 10px;
`

export const Retry = styled.button`
  padding: 10px 20px;
  color: #007bff;
  background-color: transparent;
  border: 2px solid #007bff;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #007bff;
    color: #fff;
  }
`

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
  padding: 20px;
`
